import { Menu } from './menu';

export class Trending {
  id?: number;
  menu?: Menu;
  url?: string;
  hits?: number;
  image?: string;
  title?: string;
  type?: string;
  createdAt?: Date;
}
